/**
 * Community Reviews Slider
 * - No dependencies, native scroll-snap
 * - Lazy-init via IntersectionObserver
 * - Multiple instances safe
 */
(function () {
  'use strict';

  class CommunityReviews {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-cr-track]');
      this.prevBtn = root.querySelector('[data-direction="prev"]');
      this.nextBtn = root.querySelector('[data-direction="next"]');
      if (!this.track) return;

      this.bindEvents();
      this.updateNavState();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scroll(1));
      }

      // Throttled scroll listener for nav state
      let ticking = false;
      this.track.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            requestAnimationFrame(() => {
              this.updateNavState();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );

      // Read-More toggles (event delegation)
      this.root.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-cr-toggle]');
        if (!toggle) return;
        const body = toggle.previousElementSibling;
        const isExpanded = toggle.dataset.expanded === 'true';
        body.textContent = isExpanded ? toggle.dataset.truncated : toggle.dataset.full;
        toggle.dataset.expanded = String(!isExpanded);
        toggle.textContent = isExpanded ? 'Read More' : 'Read Less';
      });
    }

    scroll(direction) {
      const card = this.track.querySelector('.community-reviews__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
      const distance = (card.offsetWidth + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateNavState() {
      if (!this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      this.prevBtn.disabled = atStart;
      this.nextBtn.disabled = atEnd;
    }
  }

  // Lazy init
  const initObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          new CommunityReviews(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '200px' }
  );

  document.querySelectorAll('[data-section-type="community-reviews"]').forEach((el) => {
    initObserver.observe(el);
  });

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-section-type="community-reviews"]');
    if (section) new CommunityReviews(section);
  });
})();